import { Fragment, useCallback, useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import FormTerritory, { TerritoryForm } from 'system/geographic/components/territory/form';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonTerritoryCrumbs } from '../constants';
import { HttpResponse } from 'shell/models/http-response';
import { Territory } from 'shell/models/territory';
import TableConsulate from 'system/geographic/components/territory/form/consulate-table';
import { ConsulateClient } from '../../consulate/list/types';

const TerritoryDetailPage = (): React.ReactElement => {
  const params = useParams();

  const {
    get: getTerritory,
    data,
    error,
    loading,
  } = useHttpFetch<HttpResponse<Territory>>(
    `${__MUNICIPALITY_API_URL__}/geo/territorio/${params.id}`
  );

  useEffect(() => {
    getTerritory();
  }, []);

  const territory: TerritoryForm = useMemo(() => {
    const territoryPayload = data?.payload;
    if (!territoryPayload || !!error) {
      return {};
    }
    return {
      code: territoryPayload.key.codice,
      exonym: territoryPayload.esonimo,
      endonym: territoryPayload.endonimo,
      state: territoryPayload.codiceStato,
      electoralAgreement: territoryPayload.flagIntesa === 'S',
      continent: territoryPayload.codiceContinente,
    };
  }, [data, error]);

  const navigate = useNavigate();

  const onSubmit = useCallback(() => {
    return;
  }, []);

  const consulates: Array<ConsulateClient> = useMemo(() => {
    const payload = data?.payload;

    if (!payload || !payload.consolati || error) {
      return [];
    }

    return payload.consolati.map((consulate) => ({
      code: consulate.key.codice,
      description: consulate.nome,
      municipality: consulate.comune?.nome?.toString() || '',
    }));
  }, [data?.payload, error]);

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonTerritoryCrumbs, { name: 'Dettaglio Territorio' }]} />
      {loading || error || !data ? undefined : (
        <FormTerritory
          title="Dettaglio Territorio"
          onOk={onSubmit}
          initialValues={territory}
          disabled
          onCancel={() => {
            navigate('/sistema/geografiche/estero/territorio');
          }}
        >
          {consulates.length > 0 ? <TableConsulate consulates={consulates} /> : undefined}
        </FormTerritory>
      )}
    </Fragment>
  );
};

TerritoryDetailPage.displayName = 'Territory Detail page component';

export default TerritoryDetailPage;
